<template>
  <div class="layout overflow-hidden">
    <PreviewNavbar v-if="eventPreviewPage"></PreviewNavbar>
    <navbar v-else></navbar>
    <div id="layoutContent" class="content d-flex" :style="contentStyle">
      <main
        id="layoutContentMain"
        class="w-100 d-flex flex-column position-relative"
      >
        <breadcrumb v-if="hasBreadcrumb"></breadcrumb>
        <NotFound v-if="isNotFound"></NotFound>
        <div v-else class="content-container">
          <slot></slot>
        </div>
        <Footer v-if="!device.isMobile && !eventPreviewPage"></Footer>
      </main>
    </div>
    <BottomNav v-if="!eventPreviewPage"></BottomNav>
  </div>
</template>

<script>
import Navbar from '@/layouts/Navbar.vue';
import Breadcrumb from '@/layouts/Breadcrumb.vue';
import Footer from '@/layouts/Footer.vue';
import BottomNav from '@/layouts/BottomNav.vue';
import NotFound from '@/layouts/NotFound.vue';
import PreviewNavbar from '@/layouts/PreviewNavbar.vue';
import delay from '@/lib/base/delay';

export default {
  components: {PreviewNavbar, Navbar, Breadcrumb, BottomNav, Footer, NotFound},
  computed: {
    device() {
      return this.$store.getters['env/device'];
    },
    hasBreadcrumb() {
      return !['home-page', 'exam-room'].includes(this.$route?.name);
    },
    isNotFound() {
      return this.$store.getters['env/notFound'];
    },
    eventPreviewPage() {
      return Boolean(
        this.$route.query.preview &&
          (this.$route.name === 'eventInformation' ||
            this.$route.name === 'examInformation')
      );
    },
    deviceHeight() {
      return this.$store.state.env.height;
    },
    userAgent() {
      return this.$store.state.env.userAgent;
    },
    contentStyle() {
      return {
        height: this.device.isMobile
          ? `calc(${this.deviceHeight}px - 121px)`
          : '',
      };
    },
  },
  async mounted() {
    const isFb = this.userAgent.ua.includes('FBAN');
    if (isFb) {
      await delay(500);
      this.$store.dispatch('env/init');
    }
  },
};
</script>
<style lang="scss" scoped>
.layout {
  background: $gray-100;
  display: flex;
  flex-direction: column;
  height: 100%;
  @media screen and (min-width: 768px) {
    height: 100vh;
  }
  .content {
    flex: 1;
    overflow: overlay;

    main {
      overflow-x: hidden;
      position: absolute;
      top: 0;
      bottom: 0;
      flex-grow: 1;
      .content-container {
        flex-grow: 1;
      }
    }
  }
}
</style>
